<div class="text-center">
    <h1>Hi, Welcome to Magalies Pharmaceuticals</h1>
</div>
<mat-card *authGroup="dashboardCardRoles" class="ui-wrapper">
        <div class="row">
            <div class="col-md-6 p-2">
                <mat-card>

                    <div class="row">
                        <div class="col-md-2">
                            <mat-card-title>Orders</mat-card-title>
                        </div>
                        <div class="col-md-10 text-end" *ngIf="perm.canMutateDashboard()">
                            <a routerLink="/portal/submit" mat-raised-button color="primary">
                                <mat-icon>add</mat-icon> New prescription
                            </a>
                        </div>
                    </div>

                    <form [formGroup]="ordersDateRangeForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="ordersPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="ordersPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #ordersPicker></mat-date-range-picker>
                        </mat-form-field>

                    </form>

                    <core-statistics [data]="ordersData" [config]="ordersConfig" [heading]="'Orders'"></core-statistics>
                    <mat-card-actions *ngIf="perm.canMutateDashboard()">
                        <div class="text-end">
                            <!-- Report-type mat-selects: no mat-label — avoids Chrome Issues on <label for> vs non-labelable custom element; see NewKnowledgeBase.md -->
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-select
                                    id="dashboard-orders-report-type"
                                    placeholder="Report type"
                                    aria-label="Report type"
                                    [formControl]="downloadOrdersReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button [disabled]="downloadOrdersReportControl.invalid || ordersDateRangeForm.invalid" class="me-2" mat-stroked-button
                                (click)="generateAndDownloadOrders()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="col-md-6 p-2">
                <mat-card>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-card-title>Batches</mat-card-title>
                        </div>
                        <div class="col-md-6 text-end" *ngIf="perm.canMutateDashboard()">
                            <a routerLink="/portal/batches/create" mat-raised-button color="primary">
                                <mat-icon>add</mat-icon> New batch
                            </a>
                        </div>
                    </div>

                    <form [formGroup]="batchesDateRangeForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="batchesPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="batchesPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #batchesPicker></mat-date-range-picker>
                        </mat-form-field>

                    </form>

                    <core-statistics [data]="batchesData" [config]="batchesConfig" [heading]="'Batches'">
                    </core-statistics>

                    <mat-card-actions *ngIf="perm.canMutateDashboard()">
                        <div class="text-end">
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-select
                                    id="dashboard-batches-report-type"
                                    placeholder="Report type"
                                    aria-label="Report type"
                                    [formControl]="downloadBatchesReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button mat-stroked-button [disabled]="downloadBatchesReportControl.invalid || batchesDateRangeForm.invalid" class="me-2"
                                (click)="generateAndDownloadBatches()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="col-md-12 p-2">
                <mat-card>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-card-title>Medicine</mat-card-title>
                        </div>
                        <div class="col-md-6 text-end" *ngIf="perm.canMutateDashboard()">
                            <a routerLink="/portal/medicine/create" mat-raised-button color="primary">
                                <mat-icon>add</mat-icon> New medicine
                            </a>
                        </div>
                    </div>

                    <form [formGroup]="medicineDateRangeForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="medicinePicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="medicinePicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #medicinePicker></mat-date-range-picker>
                        </mat-form-field>

                        <mat-form-field class="criteria me-2" appearance="outline">
                            <mat-select required data-testid="criteria" formControlName="criteria">
                                <mat-option *ngFor="let criteria of criterias" [value]="criteria.value">
                                    {{criteria.type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Search for a individual</mat-label>
                            <input type="text" placeholder="Search for a individual"
                                aria-label="Search for a individual" matInput formControlName="doctorName"
                                [matAutocomplete]="auto">
                            <mat-autocomplete (optionSelected)="doctorSelected($event)" autoActiveFirstOption
                                #auto="matAutocomplete">
                                <mat-option *ngFor="let doctor of doctors" [value]="doctor">
                                    {{doctor.first_name + ' ' + doctor.last_name}}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-icon matPrefix>search</mat-icon>
                            <button *ngIf="selectedDoctor" (click)="deselectDoctor()" mat-icon-button matSuffix
                                [attr.aria-label]="'Remove individual'">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Search for a company</mat-label>
                            <input type="text" placeholder="Search for a company"
                                aria-label="Search for a company" matInput formControlName="companyName"
                                [matAutocomplete]="companyAuto">
                            <mat-autocomplete (optionSelected)="companySelected($event)" autoActiveFirstOption
                                #companyAuto="matAutocomplete">
                                <mat-option *ngFor="let company of companies" [value]="company">
                                    {{company.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-icon matPrefix>search</mat-icon>
                            <button *ngIf="selectedCompany" (click)="deselectCompany()" mat-icon-button matSuffix
                                [attr.aria-label]="'Remove company'">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>     
                    </form>

                    <core-medicine-report [data]="medicineReportData" [config]="medicineReportConfig"
                        [heading]="'Medicine report'">
                    </core-medicine-report>

                    <mat-card-actions *ngIf="perm.canMutateDashboard()">
                        <div class="text-end">
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-select
                                    id="dashboard-medicine-report-type"
                                    placeholder="Report type"
                                    aria-label="Report type"
                                    [formControl]="downloadMedicineReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button class="me-2" [disabled]="downloadMedicineReportControl.invalid" mat-stroked-button
                                (click)="generateAndDownloadMedicine()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>

                <mat-card>

                    <div class="row">
                        <div class="col-md-12">
                            <mat-card-title>Deliveries</mat-card-title>
                        </div>                      
                    </div>

                    <form [formGroup]="deliveryReportDataForm">

                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="diffPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-hint>YYYY/MM/DD – YYYY/MM/DD</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="diffPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #diffPicker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Search for a Distributor</mat-label>
                            <input type="text" placeholder="Search for a Distributor"
                              aria-label="Search for a distributor" matInput formControlName="distributorName"
                              [matAutocomplete]="distributorAuto">
                            <mat-autocomplete (optionSelected)="distributorSelected($event)" autoActiveFirstOption
                              #distributorAuto="matAutocomplete">
                              <mat-option *ngFor="let distributor of distributors" [value]="distributor">
                                {{distributor.name}}
                              </mat-option>
                            </mat-autocomplete>
                            <mat-icon matPrefix>search</mat-icon>
                            <button *ngIf="selectedDistributor" (click)="deselectDistributor()" mat-icon-button matSuffix
                              [attr.aria-label]="'Remove Distributor'">
                              <mat-icon>cancel</mat-icon>
                            </button>
                          </mat-form-field>
                    </form>

                    <mat-card-actions *ngIf="perm.canMutateDashboard()">
                        <div class="text-start">
                            <mat-form-field class="me-2" appearance="outline">
                                <mat-select
                                    id="dashboard-deliveries-report-type"
                                    placeholder="Report type"
                                    aria-label="Report type"
                                    [formControl]="downloadDelReportControl">
                                    <mat-option value="csv">CSV</mat-option>
                                    <mat-option value="excel">Excel</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button [disabled]="downloadDelReportControl.invalid || deliveryReportDataForm.invalid" class="me-2" mat-stroked-button
                                (click)="generateAndDownloadDelivery()">
                                <mat-icon>file_download</mat-icon> Download
                            </button>
                        </div>
                    </mat-card-actions>
                </mat-card>

                <!-- Vetscripts daily shipped report (manual): pick date, get signed download URL -->
                <mat-card class="mt-2">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-card-title>Vetscripts daily shipped report</mat-card-title>
                        </div>
                    </div>
                    <p class="text-muted small mb-2">Generate a CSV of Vetscripts orders that shipped on a chosen date. Leave date empty for today (UTC). The scheduled report also runs daily at 5pm SAST and is sent by email.</p>
                    <mat-form-field class="me-2" appearance="outline">
                        <mat-label>Report date (optional)</mat-label>
                        <input matInput [matDatepicker]="vetscriptsDatePicker" [formControl]="vetscriptsReportDateControl" placeholder="YYYY-MM-DD">
                        <mat-datepicker-toggle matSuffix [for]="vetscriptsDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #vetscriptsDatePicker></mat-datepicker>
                        <mat-hint>YYYY-MM-DD; empty = today</mat-hint>
                    </mat-form-field>
                    <button *ngIf="perm.canMutateDashboard()" mat-stroked-button [disabled]="vetscriptsReportLoading" (click)="generateVetscriptsShippedReport()">
                        <mat-icon *ngIf="!vetscriptsReportLoading">file_download</mat-icon>
                        <mat-spinner *ngIf="vetscriptsReportLoading" diameter="20" class="me-1"></mat-spinner>
                        {{ vetscriptsReportLoading ? 'Generating…' : 'Download report' }}
                    </button>
                </mat-card>

                <!-- Split Orders report: download only (CSV/Excel). Optional date range and distributor. -->
                <mat-card class="mt-2">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-card-title>Split Orders report</mat-card-title>
                        </div>
                    </div>
                    <p class="text-muted small mb-2">Download split orders (parent/child) as CSV or Excel. Optional filters: order placed date range and distributor. Leave empty for all split orders.</p>
                    <form [formGroup]="splitOrdersDateRangeForm">
                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Date range (optional)</mat-label>
                            <mat-date-range-input [rangePicker]="splitOrdersPicker">
                                <input formControlName="start" matStartDate placeholder="Start date">
                                <input formControlName="end" matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="splitOrdersPicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #splitOrdersPicker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-form-field class="me-2" appearance="outline">
                            <mat-label>Distributor (optional)</mat-label>
                            <input matInput placeholder="Search distributor" [formControl]="splitOrdersDistributorName"
                                [matAutocomplete]="splitOrdersDistributorAuto">
                            <mat-autocomplete #splitOrdersDistributorAuto="matAutocomplete" (optionSelected)="splitDistributorSelected($event)" autoActiveFirstOption>
                                <mat-option *ngFor="let c of splitOrdersDistributors" [value]="c">{{ c.name }}</mat-option>
                            </mat-autocomplete>
                            <mat-icon matPrefix>search</mat-icon>
                            <button *ngIf="selectedSplitDistributor" mat-icon-button matSuffix (click)="deselectSplitDistributor()" type="button" aria-label="Clear distributor">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-form-field>
                    </form>
                    <mat-card-actions *ngIf="perm.canMutateDashboard()">
                        <mat-form-field class="me-2" appearance="outline">
                            <mat-select
                                id="dashboard-split-orders-report-type"
                                placeholder="Report type"
                                aria-label="Report type"
                                [formControl]="downloadSplitOrdersReportControl">
                                <mat-option value="csv">CSV</mat-option>
                                <mat-option value="excel">Excel</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-stroked-button [disabled]="downloadSplitOrdersReportControl.invalid || splitOrdersDownloadLoading" (click)="generateAndDownloadSplitOrders()">
                            <mat-icon *ngIf="!splitOrdersDownloadLoading">file_download</mat-icon>
                            <mat-spinner *ngIf="splitOrdersDownloadLoading" diameter="20" class="me-1"></mat-spinner>
                            {{ splitOrdersDownloadLoading ? 'Downloading…' : 'Download' }}
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
</mat-card>